import {
    Component,
    EventEmitter,
    Input,
    Output,
    ViewChild,
} from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';
import { MatMenuModule, MatMenuTrigger } from '@angular/material/menu';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatIconModule } from '@angular/material/icon';

import { CheckboxComponent } from '@shared/checkbox/checkbox.component';
import { FlatButtonComponent } from '@shared/button/flat-button/flat-button.component';
import { TextButtonComponent } from '@shared/button/text-button/text-button.component';
import { DiscrepancyViewColumnOptionsComponent } from './discrepancy-view-column-options.component';
import { StopClickDirective } from '@directives/stop-click.directive';
import { TableView } from '@constants/table';
import { ColumnOption } from '@models/shared.model';
import DATA_QA from '@automation/data-qa.json';

@Component({
    selector: 'app-table-view-menu',
    templateUrl: './table-view-menu.component.html',
    styleUrl: './table-view-menu.component.scss',
    imports: [
        MatMenuModule,
        MatButtonToggleModule,
        MatIconModule,
        MatDividerModule,
        FlatButtonComponent,
        TextButtonComponent,
        DiscrepancyViewColumnOptionsComponent,
        CheckboxComponent,
        StopClickDirective,
    ],
})
export class TableViewMenuComponent {
    @Input() selected: TableView = TableView.Document;
    @Input({ required: true }) docOptions: ColumnOption<any>[] = [];
    @Input({ required: true }) nestedDocOptions: ColumnOption<any>[] = [];
    @Input({ required: true }) discOptions: ColumnOption<any>[] = [];
    @Output() tableViewChanged = new EventEmitter<TableView>();
    @Output() docOptionsChanged = new EventEmitter<{
        checked: boolean;
        id: string;
    }>();
    @Output() nestedDocOptionsChanged = new EventEmitter<{
        checked: boolean;
        id: string;
    }>();
    @Output() disccOptionsChanged = new EventEmitter<{
        checked: boolean;
        id: string;
    }>();

    @ViewChild(MatMenuTrigger) trigger: MatMenuTrigger | undefined;

    menuOpened = false;
    readonly dataQa = DATA_QA;
    readonly tableView = TableView;

    get description() {
        return this.selected === TableView.Document
            ? `Document view shows both document’s and discrepancy information in
            the same table by grouping discrepancies under documents.`
            : 'Discrepancy view lists each discrepancy separately in the table.';
    }

    changeTableView(tableView: TableView) {
        this.tableViewChanged.emit(tableView);
    }

    closeMenu() {
        if (this.trigger) this.trigger.closeMenu();
    }

    docChanged(checked: boolean, id: string) {
        this.docOptionsChanged.emit({
            checked,
            id,
        });
    }

    nestedDocChanged(checked: boolean, id: string) {
        this.nestedDocOptionsChanged.emit({
            checked,
            id,
        });
    }

    discChanged(e: { checked: boolean; id: string }) {
        this.disccOptionsChanged.emit({
            checked: e.checked,
            id: e.id,
        });
    }
}
